import React from 'react';
import { useSelector } from 'react-redux';

import { useFreecodeContextData } from 'hooks/useContext';
import { Checkbox } from 'components/Checkbox/Checkbox';
import Dropdown from 'components/Dropdown/Dropdown';
import { categories } from 'constants/tests';
import { userRoles } from 'constants/users';
import { CreatorSection, SectionHeader, Label, InputContainer, NumberInput } from '../styles';

const categoryOptions = { code: 'Code Test', challenge: 'Challenge', exercise: 'Exercise' };

const difficultyEasy = 'Easy';
const difficultyMedium = 'Medium';
const difficultyHard = 'Hard';

const difficulties = [difficultyEasy, difficultyMedium, difficultyHard];

const difficultyOptions = [
  { label: 'None', value: null },
  { label: difficultyEasy, value: difficultyEasy },
  { label: difficultyMedium, value: difficultyMedium },
  { label: difficultyHard, value: difficultyHard },
];

export default function FreecodeTestMeta() {
  const { test, setTest, testImpl, setTestImpl } = useFreecodeContextData();

  const { userRole } = useSelector((state) => state.auth);

  const updateDifficulty = (option) => {
    setTest((oldTest) => {
      let difficulty = option.value;
      let tags = (oldTest.tags || []).filter((tag) => !difficulties.includes(tag));
      if (difficulty) tags.push(difficulty);
      return { ...oldTest, difficulty, tags };
    });
  };

  return (
    <CreatorSection>
      <SectionHeader>Test Meta</SectionHeader>
      <InputContainer>
        <Label noWrap>Category: {categoryOptions[test.category]}</Label>
      </InputContainer>
      {test.category === categories.CHALLENGE.category && (
        <InputContainer>
          <Checkbox
            checked={test.isTournament}
            label="Is Tournament"
            title="In a tournament solutions compete against each other"
            onChange={() => setTest((oldTest) => ({ ...oldTest, isTournament: !oldTest.isTournament }))}
          />
        </InputContainer>
      )}
      {test.category === categories.EXERCISE.category && (
        <InputContainer>
          <Checkbox
            checked={test.isFreecode}
            label="Is Freecode"
            title='A freecode exercise might be a demonstration without a "solution"'
            onChange={() => setTest((oldTest) => ({ ...oldTest, isFreecode: !oldTest.isFreecode }))}
          />
        </InputContainer>
      )}
      {test.isTournament && (
        <InputContainer>
          <Label noWrap>Number of players:</Label>
          <NumberInput
            value={testImpl.numPlayers}
            onChange={(e) => setTestImpl((oldImpl) => ({ ...oldImpl, numPlayers: Math.max(2, e.target.value) }))}
          ></NumberInput>
        </InputContainer>
      )}
      <InputContainer>
        <Label noWrap>Difficulty:</Label>
        <Dropdown
          value={test.difficulty || 'None'}
          options={difficultyOptions}
          onChange={updateDifficulty}
          width="auto"
        />
      </InputContainer>
      {test.category === categories.CODE.category && (
        <InputContainer>
          <Checkbox
            checked={testImpl.enableSkeletonEditing}
            label="Allow custom skeleton"
            title="Allow creator to edit the skeleton code. This is discouraged for most tests. This will prevent adding new solution API functions and disable the generate skeleton function."
            onChange={() =>
              setTestImpl((oldImpl) => ({ ...oldImpl, enableSkeletonEditing: !oldImpl.enableSkeletonEditing }))
            }
          />
        </InputContainer>
      )}
      {userRole === userRoles.SUPER_ADMIN && test.category === categories.CODE.category && (
        <InputContainer>
          <Checkbox
            checked={test.isPremium}
            label="Is Premium"
            title="Set the test to be premium"
            onChange={() => setTest((oldTest) => ({ ...oldTest, isPremium: !oldTest.isPremium }))}
          />
        </InputContainer>
      )}
      {test.category === categories.CODE.category && (
        <InputContainer>
          <Label noWrap>Time Limit:</Label>
          <NumberInput
            value={test.duration}
            onChange={(e) => setTest((oldTest) => ({ ...oldTest, duration: e.target.value }))}
          ></NumberInput>
        </InputContainer>
      )}
    </CreatorSection>
  );
}
